import { REFERENCE_MODEL_TYPE } from './global';
import { IKamClient } from './kamClient.types';

export interface IBussinesDetail {
  id: number;
  name: string;
  businessName: string;
  document: string;
  countryCode: string;
  numberOfEmployees: number;
  address: string;
  documentTypeId: number;
  stateId: number;
  deletedAt: string;
  createdAt: string;
  updatedAt: string;
  credit?: ICreditdDetail;
  country?: ICountryDetail;
  organizationCommercialPreferences: IorganizationCommercialPreferenceDetail[];
}
export interface ICreditdDetail {
  id: number;
  organizationId: number;
  approvedDays: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
}

export interface ICreditOrganization {
  commercialPreferenceValue: string | number;
  organizationId: number;
  commercialPreferenceTypeUuid: string;
}

export enum TYPE_PAYMENT_AGREEMENT {
  ORDER = 'order',
  SERVICE = 'service',
  BOTH = 'both'
}

export enum UUID_PAYMENT_AGREEMENT {
  REQUIRE_PAYMENT_AGREEMENT_FOR_ORDER = 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  REQUIRE_PAYMENT_AGREEMENT_FOR_SERVICE = '8cad444b-cfe8-4118-a3d4-9e8f99ad102a'
}

export enum ID_PAYMENT_AGREEMENT {
  REQUIRE_PAYMENT_AGREEMENT_FOR_ORDER = 4,
  REQUIRE_PAYMENT_AGREEMENT_FOR_SERVICE = 5
}

export interface IPhoneData {
  country: string;
  countryId: number;
  flag: string;
  phone: string;
  phoneCode: string;
}

export interface IOrganizationUserData {
  address?: string | null;
  countryCode?: string | null;
  email?: string | null;
  firstName?: string | null;
  id?: number | null;
  lastName?: string | null;
  phone?: string | null;
  photoProfile?: string | null;
  role?: string | null;
  stateId?: number | null;
  uid?: string | null;
  phoneData?: IPhoneData;
}

export interface ICountryDetail {
  code: string;
  flag: string;
  id: number;
  name: string;
}

export interface ISpecialBusinessNameType {
  id?: number;
  name?: string;
  description?: string;
  countryId?: number;
}

export interface IBillingData {
  id: number;
  country: string;
  countryCode?: string;
  flag: string;
  bussinesName: string;
  countryDocument: string;
  countryFlagDocument: string;
  specialBusinessNameType?: ISpecialBusinessNameType;
  specialBusinessNameTypeId?: number;
  document: string;
  city: string;
  zipCode: string;
  state: string;
  additionalReferences: string;
  email: string;
  address: string;
  taxSituationDocUrl?: string;
  taxSituationId?: number | null;
  taxUseId?: number | null;
}

export interface IBillingForm {
  countryId?: number;
  documentCountryId?: string | number;
  name?: string;
  businessName?: string;
  document?: string;
  city?: string;
  zipCode?: string;
  state?: string;
  additionalReferences?: string;
  email?: string;
  address?: string;
  taxSituationDocUrl?: string | null;
  taxSituationId?: number | null;
  taxUseId?: number | null;
}

export interface IProductsCare {
  nudosCare: 'Free' | 'Basic' | 'Log' | 'Full';
  nudosId: string;
  productId: number;
  productName: string;
  serial: null | string;
  startDate: null | string;
  endDate: null | string;
  referenceCatalog: REFERENCE_MODEL_TYPE;
  isKit?: boolean;
}

export interface IBasicProductsCare {
  productId: number;
  nudosCare: number;
}

export interface ISubscriptionsDetails {
  levelSubscription: 'Lite' | 'Free';
  pricePerMonth: null | string;
  pricePerYear: null | string;
  startDate: null | string;
  endDate: null | string;
}

export interface IProductsPerCategory {
  category: string;
  numberOfTools: number;
}

export interface ITags {
  id: number;
  uuid: string;
  name: string;
}

export interface IorganizationBusinessData {
  uuid?: string | null;
  id: number;
  levelSubscription: string;
  businessName?: string | null;
  creationDate?: string | null;
  document?: string | null;
  name?: string | null;
  countryCode?: string | null;
  statusName?: string | null;
  users?: IOrganizationUserData[];
  country?: ICountryDetail;
  employeesCreated?: boolean;
  loadedTools?: boolean;
  billingData: IBillingData[];
  productsCare: IProductsCare[];
  subscriptionsDetails: ISubscriptionsDetails;
  productsPerCategory?: IProductsPerCategory[];
  organizationCommercialPreferences?: IorganizationCommercialPreference[];
  organizationType: IOrganizationType;
  availableKams?: IKamClient[];
  assignedKam?: IKamClient | null;
  assignedTags?: ITags[];
  availableTags?: ITags[];
}

export interface IUpdateSusbcriptions {
  platformSubscriptionId: number;
  pricePerMonth?: number | null;
  pricePerYear?: number | null;
  startDate?: string;
  endDate?: string;
}

export interface IUpdateOrganizationType {
  organizationTypeId: number;
}

export interface IUpdateSpecialBusinessNameBody {
  billingDataId?: number;
  specialBusinessNameTypeId?: number;
}

export interface ICountryData {
  id: number;
  name?: string;
  code: string;
  flag: string;
  timeZone?: number;
  nameStringId: string;
}

export interface ISpecialBusinessNameTypesByCountry {
  id?: number;
  name: string;
  description?: string;
  countryId?: number;
  country?: ICountryData;
}
export interface ISpecialBusinessNameTypes {
  [key: string]: ISpecialBusinessNameTypesByCountry[];
}

export interface organizationCommercialPreferenceCreateDto {
  organizationId: number;
  commercialPreferenceTypeUuid: string;
  commercialPreferenceValue: string;
}

export enum COMMERCIAL_PREFERENCE_TYPES_UUIDS {
  REQUIRE_PURCHASE_ORDER_FOR_ECOMMERCE_SALE = '09adc00f-db57-4ab7-b31d-3322f69446ee',
  REQUIRE_PURCHASE_ORDER_FOR_LOGISTIC_SERVICE = 'b4713b7e-b8ca-42ce-b253-2149510e35ae'
}

export interface IorganizationCommercialPreference {
  commercialPreferenceTypeUuid: string;
  commercialPreferenceValueType: string;
  commercialPreferenceValue: string; // This value is a JSON string, so it should be parsed
}

export type IorganizationCommercialPreferenceDetail = {
  commercialPreferenceTypeId: number;
  commercialPreferenceValue: number;
};

export interface IOrganizationType {
  id: number;
  name: string;
  nameStringId: string;
}

export interface ITagName {
  name: string;
}

export interface IAssignTag {
  organizationId: number;
  organizationsTagsIds: number[];
}

export interface IDeleteTagOrganziation {
  organizationId: number;
  organizationsTagId: number;
}

export interface IEmailInvitation {
  email: string;
  organizationId: number;
  isInvite: true;
}

export interface IFilterValues {
  id: number;
  name: string;
  email?: string;
}

export interface IListingFilters {
  tagFilterValues: IFilterValues[];
  kamFilterValues: IFilterValues[];
  clientFilterValues: IFilterValues[];
  commercialPreferenceTypeFilterValues: IFilterValues[];
}

export interface Iorganization {
  id: number;
  uuid: string;
  name: string;
  businessName: string;
  document: string;
}

export interface ICountriesData {
  [countryCode: string]: ICountryInfo;
}

export interface ICountryInfo {
  countryData?: ICountryData;
  billingEntities?: IBillingEntity[];
  canCreateNew?: boolean;
}

export interface IBillingEntity {
  id: number;
  countryId: number;
  countryCode: string;
  organizationId: number;
  name: string;
  businessName: string;
  specialBusinessNameTypeId: number | null;
  fantasyName: string | null;
  document: string;
  documentCountryId: number;
  address: string;
  additionalReferences: string | null;
  email: string;
  street: string | null;
  number: string | null;
  internalNumber: string | null;
  colony: string | null;
  zipCode: string;
  city: string;
  state: string;
  taxSituationDocUrl: string | null;
  taxSituationId: number | null;
  taxUseId: number | null;
  phoneCountryId: number | null;
  phone: string | null;
  deletedAt: string | null;
  documentCountry: ICountryData;
  phoneCountry: ICountryData | null;
  taxSituation: ITaxSituation | null;
  taxUse: ITaxUse | null;
}

export interface ITaxSituation {
  id: number;
  code: string;
  name: string;
}

export interface ITaxUse {
  id: number;
  code: string;
  name: string;
}

export enum CURRENCIES {
  USD = 'USD',
  ARS = 'ARS',
  BRL = 'BRL',
}
